<template>
  <div id="xdh-map-container" class="xdh-device-map">
    <el-autocomplete
      v-model="filterText"
      :fetch-suggestions="querySearch"
      placeholder="请输入内容"
      @select="handleSelect"
    >
      <img slot="prefix" src="@/assets/img/icon_search.png">
    </el-autocomplete>
    <xdh-map ref="xdhMap" :zoom.sync="mapZoom" :center.sync="mapCenter" @ready="handleMapLoad">
      <xdh-map-image v-if="gisMarkers.length > 0" v-for="item in gisMarkers"
                     :key="item.id"
                     v-bind="item" @click="handleGisMarkerClick">
      </xdh-map-image>
      <!--缩放工具-->
      <xdh-map-zoom
        placement="left-top"
        theme="light"
        :margin="[10, 10]"
      ></xdh-map-zoom>
      <!--比例尺工具-->
      <xdh-map-scale v-if="scaleBarVisible" units="metric"></xdh-map-scale>
      <!--缩略图控件-->
      <xdh-map-overview placement="right-bottom"
                        :margin="[10, 10]"></xdh-map-overview>
      <!--取点工具-->
      <xdh-map-pointer v-if="coordinateConversionVisible" placement="right-top"
                       :margin="[60,10]"
                       @copy="handleCoordinateCopy"></xdh-map-pointer>
      <!--测量工具-->
      <xdh-map-measure v-show="distanceMeasurementVisible" ref="measure"></xdh-map-measure>
      <!--工具栏-->
      <xdh-map-placement placement="right-top" :margin="[10, 10]" theme="light">
        <div id="tool-bar">
          <el-dropdown :hide-on-click="false" trigger="click">
        <span class="el-dropdown-link">
          <i class="el-icon-s-operation"></i>
          选择
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
            <el-dropdown-menu slot="dropdown">
              <el-radio-group v-model="selectionType" @change="handleBoxRadio">
                <el-dropdown-item>
                  <el-radio label="1">点选</el-radio>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-radio label="2">框选</el-radio>
                </el-dropdown-item>
              </el-radio-group>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown :hide-on-click="false" trigger="click">
        <span class="el-dropdown-link">
          <i class="el-icon-s-flag"></i>
          标注
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
            <el-dropdown-menu slot="dropdown">
              <el-radio-group v-model="classificationMethod" @change="handleRadio">
                <el-dropdown-item>
                  <el-radio label="1">不标注</el-radio>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-radio label="2">按地域标注</el-radio>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-radio label="3">按行业标注</el-radio>
                </el-dropdown-item>
              </el-radio-group>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown @command="handleCommand" placement="bottom" trigger="click">
        <span class="el-dropdown-link">
          <i class="el-icon-s-cooperation"></i>
          工具箱
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="overviewMap"><i class="el-icon-check" v-show="overviewVisible"></i>鹰眼
              </el-dropdown-item>
              <el-dropdown-item command="scaleBar"><i class="el-icon-check" v-show="scaleBarVisible"></i>比例尺
              <el-dropdown-item command="distanceMeasure"><i class="el-icon-check"
                                                             v-show="distanceMeasurementVisible"></i>测距
              </el-dropdown-item>
              <el-dropdown-item command="coordinateConversion"><i class="el-icon-check"
                                                                  v-show="coordinateConversionVisible"></i>取点
              </el-dropdown-item>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </xdh-map-placement>
    </xdh-map>
    <!--显示视频节点信息弹窗-->
    <show-stream-node-modal v-if="streamNodeModalOpen" :modalOpen="streamNodeModalOpen" :gisMarker="currentGismarker"
                      @cancel="handleStreamNodeModalCancel"></show-stream-node-modal>

    <!--视频播放器窗口-->
    <video-player-modal v-if="videoPlayerModalOpen" :modalOpen="videoPlayerModalOpen" :streamNodes="selectedGismarkers"
                        :videoOpen="videoPlayerModalVideoOpen"
                        @cancel="handleVideoPlayerModalCancel"></video-player-modal>
  </div>
</template>

<script type="text/ecmascript-6">
import XdhDeviceMap from './XdhDeviceMap.js'
export default XdhDeviceMap
</script>

<style lang="scss">
@import "XdhDeviceMap.scss";
</style>



// WEBPACK FOOTER //
// src/views/monitoring/xdhDeviceMap/XdhDeviceMap.vue